import { Component, Input, inject } from "@angular/core";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "urm-core-launch-widget",
  templateUrl: "./core-launch-widget.component.html",
  styleUrls: ["./core-launch-widget.component.css"],
  imports: [MatButton]
})
export class CoreLaunchWidgetComponent {
  private clientConfigService = inject(ClientConfigService);

  @Input()
  public externalJobReference: string;
  featureEnabled: boolean = false;

  constructor() {
    const clientConfigService = this.clientConfigService;

    if (clientConfigService.config.urmServices?.launchUrl?.enableLaunchUrl) {
      this.featureEnabled = true;
    }
  }

  public launchCore() {
    const launchUrl =
      this.clientConfigService.config.urmServices.launchUrl.jobLaunchUrl.replace(
        "{externalJobReference}",
        this.externalJobReference
      );
    window.open(launchUrl, "_blank");
  }
}
